import React from 'react';
export default class PageBoundary extends React.Component<{children:React.ReactNode},{failed:boolean}> {
  state = {failed:false};
  static getDerivedStateFromError() {return {failed:true};}
  componentDidCatch(error:Error) {console.error('Strategy display failed:', error.message);}
  render() {
    if (this.state.failed) return <section role="alert"><h1>Unable to display this strategy</h1><p>The page encountered a display error. Your saved selections remain on the server. Refresh to reload them; do not repeat an order to recover the screen.</p><button onClick={()=>window.location.reload()}>Reload page</button></section>;
    return this.props.children;
  }
}
